import { CommonFrontOfficeCrumbs } from './breadcrumb';

export const LeverCrumbs = [
  ...CommonFrontOfficeCrumbs,
  {
    name: 'Certificazione Leva',
    path: '/sportello/leva',
  },
];
